import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListSysGrammarPointsV1Request } from './list-sys-grammar-points-v1-request';
import type { IListSysGrammarPointsV1Response } from './list-sys-grammar-points-v1-response';
import { listSysGrammarPointsV1ResponseSchema } from './list-sys-grammar-points-v1-response';

export async function listSysGrammarPointsV1Api(
  params: IListSysGrammarPointsV1Request = {},
  options?: IRequestOptions,
): Promise<IValidatedResponse<IListSysGrammarPointsV1Response>> {
  const search = new URLSearchParams();
  if (params.level) {
    search.set('level', params.level);
  }
  if (params.family) {
    search.set('family', params.family);
  }
  if (params.approved !== undefined) {
    search.set('approved', String(params.approved));
  }
  if (params.cursor) {
    search.set('cursor', String(params.cursor));
  }
  if (params.limit) {
    search.set('limit', String(params.limit));
  }
  const query = search.toString();

  return getRequest<IListSysGrammarPointsV1Response>({
    path: `/sys/grammar/v1/points${query ? `?${query}` : ''}`,
    schema: listSysGrammarPointsV1ResponseSchema,
    options,
  });
}
